import i18next from 'core/i18n';
import React, { useState } from 'react';

import {
  PhaseSection,
  PhaseSectionProps
} from 'features/brazil-grower/components/BrazilGrowerFinance/shared/PhaseSection';
import { SingleRow } from 'features/brazil-grower/components/BrazilGrowerFinance/shared/SingleRow';
import { IConsultingScore } from 'shared';
import { ScoreModal, ScoreModalProps } from './components/ScoreModal/ScoreModal';

export interface ScoreSectionProps extends Pick<PhaseSectionProps, 'disabled'>, Pick<ScoreModalProps, 'updateCredit'> {
  scoreSectionInfo?: IConsultingScore;
}

interface ScoreSectionSummaryProps extends Pick<ScoreSectionProps, 'scoreSectionInfo'> {}

export const ScoreSectionSummary: React.FunctionComponent<ScoreSectionSummaryProps> = ({ scoreSectionInfo }) => {
  return scoreSectionInfo ? (
    <div className="width-100">
      <SingleRow title={i18next.t('scoring')} content={scoreSectionInfo.scoreType || '-'} />
      <SingleRow title={i18next.t('number')} content={String(scoreSectionInfo.scoreNumber) || '-'} />
    </div>
  ) : null;
};

export const ScoreSection: React.FunctionComponent<ScoreSectionProps> = ({
  scoreSectionInfo,
  updateCredit,
  children,
  ...phaseSectionProps
}) => {
  /**
   * State
   */
  const [modalOpen, setModalOpen] = useState(false);

  const openScoreModal = () => setModalOpen(true);

  const closeScoreModal = () => setModalOpen(false);

  return (
    <>
      <PhaseSection
        {...phaseSectionProps}
        open={!!scoreSectionInfo}
        onClickEdit={openScoreModal}
        title={i18next.t('scoreConsulting')}
        subtitle={i18next.t('includesRequiredFields')}
        renderSeparatorBefore
      >
        <ScoreSectionSummary scoreSectionInfo={scoreSectionInfo} />
      </PhaseSection>
      <ScoreModal
        open={modalOpen}
        closeModal={closeScoreModal}
        scoreSectionInfo={scoreSectionInfo}
        updateCredit={updateCredit}
      />
    </>
  );
};
